import React, { useState, useEffect } from "react";
import axios from "axios";
import Item from "../../components/Item";
import { useCategorieMultiSelect, useOrderSingleSelect, useStatusMultiSelect } from "./hooks";

import { ImWhatsapp } from "react-icons/im";
import { FaWpforms, FaFilter } from "react-icons/fa";
import { IconContext } from "react-icons";

import {
    Container,
    TituloContainer,
    BotoesContainer,
    ListItemContainer,
    Header,
    Botao,
    FiltersContainer,
    FiltersContent,
    FilterBox
} from './styles'
import { useAuth } from "../../hooks/useAuth";
import { bitrixUrl } from "../../api/base";

type DealModel = {
    id: string;
    descricao: string;
    dataInicio: string;
    dataFechamento: string;
    fase: string;
    resolucao: string;
    nps: string;
    status: string;
    categoria: string;
    classificacao: string;
    tempoDesenvolvimento: string;
    statusDaFase: string;
    categoriasV2: string[];
    pipelineV2: string;
    idChamadoAnterior: string;
    faseV2: string;
    linkFormulario: string;
    nomeEmailUsuario: string;
    departUserModeloPermissoes: string;
    nomeRoleta: string;
    desenvolvedores: string;
    paraQuemTransferir: string;
    idCardProblema: string;
    retornoPendencia: string;
    clienteDesejaFinalizarChamado: string;
    porqueClienteEstaFinalizandoChamado: string;
    dataEntradaPendenteCliente: string;
    idResponsavel: string;
}

function parseData(data: any, timezone: string) {
    const date = new Date(String(data));
    const timeFormat: Intl.DateTimeFormatOptions = { month: '2-digit', day: '2-digit', year: '2-digit', timeZone: timezone, hour: '2-digit', minute: '2-digit' };
    let result: string = date.toLocaleString('pt-BR', timeFormat);
    return result;
}

function translateFase(fase: any) {
    switch (fase) {
        case 'C14:NEW':
            return 'Novo chamado'
        case 'C14:UC_AT3IEX':
            return 'Backlog Bot'
        case 'C14:PREPARATION':
            return 'Em análise'
        case 'C14:PREPAYMENT_INVOICE':
            return 'Pendente cliente'
        case 'C14:EXECUTING':
            return 'Pendente staff'
        case 'C14:FINAL_INVOICE':
            return 'Em andamento'
        case 'C14:1':
            return 'Solução não aprovada'
        case 'C14:WON':
            return 'Fechado'
        case 'C14:LOSE':
            return 'Desistiu'
        case 'C95:NEW':
            return 'Novo chamado'
        case 'C95:PREPARATION':
            return 'Triagem Tech Leader'
        case 'C95:PREPAYMENT_INVOIC':
            return 'Pendente Sprint'
        case 'C95:EXECUTING':
            return 'Delegado N2'
        case 'C95:FINAL_INVOICE':
            return 'Pendente cliente'
        case 'C95:UC_16COFN':
            return 'Cliente retornou'
        case 'C95:UC_Z4TWZQ':
            return 'Em andamento'
        case 'C95:UC_5ECRW9':
            return 'Solução não aprovada'
        case 'C95:WON':
            return 'Fechado'
        case 'C95:LOSE':
            return 'Cancelado'
        default:
            break;
    }
}

function translateNPS(nps: any) {
    switch (nps) {
        case '3327':
            return '00'
        case '78':
            return '01'
        case '80':
            return '02'
        case '82':
            return '03'
        case '84':
            return '04'
        case '86':
            return '05'
        case '88':
            return '06'
        case '90':
            return '07'
        case '92':
            return '08'
        case '94':
            return '09'
        case '96':
            return '10'
        default:
            break;
    }
}

function translateCategoria(categoria: any) {
    switch (categoria) {
        case '44':
            return 'Bitrix'
        case '46':
            return 'Chatbot'
        case '48':
            return 'Processos/Modelagem'
        case '50':
            return 'NiaGo'
        case '52':
            return 'Solicitação de agenda'
        case '3499':
            return '[Journey] Dúvidas - 24h úteis'
        case '3501':
            return '[Journey] Modificações nos fluxos - 24h úteis'
        case '3503':
            return '[Journey] Suporte'
        case '3505':
            return '[Journey] Sugestão de melhorias'
        default:
            break;
    }
}

function translateToCategoriaId(categoria: any) {
    switch (categoria) {
        case 'Bitrix':
            return '44'
        case 'Chatbot':
            return '46'
        case 'Processos/Modelagem':
            return '48'
        case 'NiaGo':
            return '50'
        case 'Solicitação de agenda':
            return '52'
        default:
            break;
    }
}

function translateToFaseId(fase: any) {
    switch (fase) {
        case 'Em andamento':
            return 'P'
        case 'Ganho':
            return 'S'
        case 'Desistiu':
            return 'F'
        default:
            break;
    }
}

function translateClassificacao(classificacao: any) {
    if (classificacao === undefined || classificacao === null || classificacao === 'undefined' || classificacao === 'null') {
        return '';
    }
    switch (classificacao) {
        case '8457':
            return 'Alteração'
        case '8455':
            return 'Dúvidas'
        case '8463':
            return 'Erro de implementação'
        case '8461':
            return 'Erro do sistema'
        case '8483':
            return 'Erro operacional'
        case '8459':
            return 'Integrações'
        case '8519':
            return 'Novas Solicitações'
        case '8521':
            return 'Treinamento'
        default:
            break;
    }
}

function translateStatusFaseV2(status: any) {
    if (status === undefined || status === null || status === 'undefined' || status === 'null') {
        return '';
    }
    switch (status) {
        case '10553':
            return 'Em dia'
        case '10555':
            return 'Atrasado'
        case '10557':
            return 'Pendente cliente'
        default:
            break;
    }
}

function translateCategoriasV2(category: any) {
    switch (category) {
        case '10565':
            return 'Alteração/ajuste ChatBot'
        case '10567':
            return 'Reportar problema'
        case '10569':
            return 'Problema reincidente'
        case '10571':
            return 'Erro de implementação'
        case '10573':
            return 'Alteração/ajuste de automação'
        case '10575':
            return 'Alteração de mensagens/e-mail'
        case '10577':
            return 'Alteração de formulário'
        case '10579':
            return 'Criação/ajuste de usuário'
        case '10581':
            return 'Dispensar usuário'
        case '10583':
            return 'Criação/ajuste roleta'
        case '10585':
            return 'Nova automação'
        case '10587':
            return 'Dúvidas gerais'
        default:
            break;
    }
}

function translateCategoriasV2Arr(categories: string[]) {    
    const categoriesV2String = [];
    for (const s in categories) {
        categoriesV2String.push(translateCategoriasV2(String(categories[s])));
    }
    return categoriesV2String;
}

function findCategoria(deal: DealModel) {
    if (deal.categoria) {

        return translateCategoria(deal.categoria);
    }
    if (deal.categoriasV2) {
        return translateCategoriasV2Arr(deal.categoriasV2);
    }
}

function translateCategoriasV2ToId(category: any) {
    switch (category) {
        case 'Alteração/ajuste ChatBot':
            return '10565'
        case 'Reportar problema':
            return '10567'
        case 'Problema reincidente':
            return '10569'
        case 'Erro de implementação':
            return '10571'
        case 'Alteração/ajuste de automação':
            return '10573'
        case 'Alteração de mensagens/e-mail':
            return '10575'
        case 'Alteração de formulário':
            return '10577'
        case 'Criação/ajuste de usuário':
            return '10579'
        case 'Dispensar usuário':
            return '10581'
        case 'Criação/ajuste roleta':
            return '10583'
        case 'Nova automação':
            return '10585'
        case 'Dúvidas gerais':
            return '10587'
        default:
            break;
    }
}

function translatePipelineV2(pipeline: any) {
    if (pipeline === undefined || pipeline === null || pipeline === 'undefined' || pipeline === 'null') {
        return '';
    }
    switch (pipeline) {
        case '10589':
            return 'Locação'
        case '10591':
            return 'Captação'
        case '10593':
            return 'Manutenção'
        case '10595':
            return 'Desocupação'
        case '10597':
            return 'Inadimplência'
        case '10599':
            return 'Renovação'
        case '10601':
            return 'CS / Pós-locação'
        case '10603':
            return 'Chamados'
        case '10605':
            return 'Administrativo de vendas'
        case '10695':
            return 'Outro'
        default:
            break;
    }
}

function translateClienteDesejaFinalizarV2(status: any) {
    if (status === undefined || status === null || status === 'undefined' || status === 'null') {
        return '';
    }
    switch (status) {
        case '10607':
            return 'Sim'
        case '10609':
            return 'Não'
        default:
            break;
    }
}

const MainPage: React.FC = () => {

    const { user } = useAuth();

    // const categoriesArray = ["Bitrix", "ChatBot", "Processos/Modelagem", "NiaGo", "Solicitação de agenda"];
    // const { selectedCategorie, isSelectedCategorie, onChangeCategorie } = useCategorieMultiSelect(["Bitrix", "ChatBot", "Processos/Modelagem", "NiaGo", "Solicitação de agenda"]);

    const categoriesArray = ["Alteração/ajuste ChatBot",
        "Reportar problema",
        "Problema reincidente",
        "Erro de implementação",
        "Alteração/ajuste de automação",
        "Alteração de mensagens/e-mail",
        "Alteração de formulário",
        "Criação/ajuste de usuário",
        "Dispensar usuário",
        "Criação/ajuste roleta",
        "Nova automação",
        "Dúvidas gerais"];
    const { selectedCategorie, isSelectedCategorie, onChangeCategorie } = useCategorieMultiSelect([]);

    const ordenacaoArray = ["Crescente", "Decrescente"];
    const { selectedOrder, isSelectedOrder, onChangeOrder } = useOrderSingleSelect(["Crescente"]);

    const statusArray = ["Em andamento", "Ganho", "Desistiu"];
    const { selectedStatus, isSelectedStatus, onChangeStatus } = useStatusMultiSelect(["Em andamento", "Ganho", "Desistiu"]);

    const [dataDeal, setDataDeal] = useState<DealModel[]>([]);

    const [statusFilter, setStatusFilter] = useState<boolean>(true);
    const handleFilterButton = () => {
        setStatusFilter(!statusFilter);
    }

    useEffect(() => {

        const searchCompany = user.client;

        function orderPesquisa() {
            if (selectedOrder.indexOf("Crescente") === -1) {
                return 'ASC';
            } else {
                return 'DESC';
            }
        }

        function categoriesPesquisa() {
            const categoriesPesArray = [];
            for (var cat in categoriesArray) {
                if (selectedCategorie.indexOf(categoriesArray[cat]) >= 0) {
                    categoriesPesArray.push(translateCategoriasV2ToId(categoriesArray[cat]));
                }
            }
            if (categoriesPesArray.length == 0) {
                return "";
            }
            return categoriesPesArray;
        }

        function statusPesquisa() {
            const statusPesArray = [];
            for (var s in statusArray) {
                if (selectedStatus.indexOf(statusArray[s]) >= 0) {
                    statusPesArray.push(translateToFaseId(statusArray[s]));
                }
            }
            return statusPesArray;
        }

        axios.post(bitrixUrl + '/crm.deal.list', {
            "order": {
                "ID": String(orderPesquisa())
            },
            "filter": {
                "UF_CRM_1628002553": searchCompany,
                "CATEGORY_ID": ["14", "95"],
                "STAGE_SEMANTIC_ID": statusPesquisa(),
                "UF_CRM_1622638909": "",
                "UF_CRM_1757698466": categoriesPesquisa()
            },
            "select": [
                "ID",
                "UF_CRM_1622639718",
                "UF_CRM_1622639484",
                "DATE_CREATE",
                "UF_CRM_1622638832",
                "STAGE_ID",
                "STAGE_SEMANTIC_ID",
                "UF_CRM_1622639662",
                "UF_CRM_1622638909",
                "UF_CRM_1681475502",
                "UF_CRM_1629125676",
                "UF_CRM_1757622210",
                "UF_CRM_1757698466",
                "UF_CRM_1757699573",
                "UF_CRM_1757699616",
                "UF_CRM_1757699670",
                "UF_CRM_1757699752",
                "UF_CRM_1757699794",
                "UF_CRM_1757699832",
                "UF_CRM_1757699911",
                "UF_CRM_1757704208",
                "UF_CRM_1757705324",
                "UF_CRM_1757706341",
                "UF_CRM_1758024004",
                "UF_CRM_1758024563",
                "UF_CRM_1758024599",
                "UF_CRM_1758033044",
                "UF_CRM_1758040459"
            ],
            "start": -1
        }).then(response => {
            const r = response.data.result.map((item: any): DealModel => {
                return {
                    id: item.ID,
                    dataInicio: item.DATE_CREATE,
                    dataFechamento: item.UF_CRM_1622638832,
                    descricao: item.UF_CRM_1622639718,
                    resolucao: item.UF_CRM_1622639484,
                    fase: item.STAGE_ID,
                    nps: item.UF_CRM_1622639662,
                    status: item.STAGE_SEMANTIC_ID,
                    categoria: item.UF_CRM_1622638909,
                    classificacao: item.UF_CRM_1681475502,
                    tempoDesenvolvimento: item.UF_CRM_1629125676,
                    statusDaFase: item.UF_CRM_1757622210,
                    categoriasV2: item.UF_CRM_1757698466,
                    pipelineV2: item.UF_CRM_1757699573,
                    idChamadoAnterior: item.UF_CRM_1757699616,
                    faseV2: item.UF_CRM_1757699670,
                    linkFormulario: item.UF_CRM_1757699752,
                    nomeEmailUsuario: item.UF_CRM_1757699794,
                    departUserModeloPermissoes: item.UF_CRM_1757699832,
                    nomeRoleta: item.UF_CRM_1757699911,
                    desenvolvedores: item.UF_CRM_1757704208,
                    paraQuemTransferir: item.UF_CRM_1757705324,
                    idCardProblema: item.UF_CRM_1757706341,
                    retornoPendencia: item.UF_CRM_1758024004,
                    clienteDesejaFinalizarChamado: item.UF_CRM_1758024563,
                    porqueClienteEstaFinalizandoChamado: item.UF_CRM_1758024599,
                    dataEntradaPendenteCliente: item.UF_CRM_1758033044,
                    idResponsavel: item.UF_CRM_1758040459
                }
            })
            setDataDeal(r);
        })
    }, [selectedCategorie, selectedOrder, selectedStatus])

    return (
        <Container>
            <Header>
                <TituloContainer>
                    <h1>Relação de Chamados</h1>
                </TituloContainer>
                <BotoesContainer>
                    <Botao onClick={(e) => {
                        e.preventDefault();
                        window.open('https://api.whatsapp.com/send/?phone=554899192467');
                    }}>
                        <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                            <ImWhatsapp />
                        </IconContext.Provider>
                        <h2>Entre em contato</h2>
                    </Botao>
                    <Botao onClick={(e) => {
                        e.preventDefault();
                        window.open('https://b24-evnmlj.bitrix24.site/suporte/');
                    }}>
                        <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                            <FaWpforms />
                        </IconContext.Provider>
                        <h2>Novo Chamado</h2>
                    </Botao>
                </BotoesContainer>
            </Header>
            <FiltersContainer>
                <Botao onClick={handleFilterButton}>
                    <IconContext.Provider value={{ color: 'black', size: '25px' }}>
                        <FaFilter />
                    </IconContext.Provider>
                    <h3>Filtros</h3>
                </Botao>
                {statusFilter ? <> </> : <FiltersContent>
                    <FilterBox>
                        <h4>Categorias:</h4>
                        <ul style={{ listStyleType: "none" }}>
                            {categoriesArray.map((value) => (
                                <li key={value}>
                                    <input
                                        id={value}
                                        type="checkbox"
                                        value={value}
                                        checked={isSelectedCategorie(value)}
                                        onChange={onChangeCategorie}
                                    />
                                    <label htmlFor={value}>{value}</label>
                                </li>
                            ))}
                        </ul>
                    </FilterBox>
                    <FilterBox>
                        <h4>Status:</h4>
                        <ul style={{ listStyleType: "none" }}>
                            {statusArray.map((value) => (
                                <li key={value}>
                                    <input
                                        id={value}
                                        type="checkbox"
                                        value={value}
                                        checked={isSelectedStatus(value)}
                                        onChange={onChangeStatus}
                                    />
                                    <label htmlFor={value}>{value}</label>
                                </li>
                            ))}
                        </ul>
                    </FilterBox>
                    <FilterBox>
                        <h4>Ordenação:</h4>
                        <ul style={{ listStyleType: "none" }}>
                            {ordenacaoArray.map((value) => (
                                <li key={value}>
                                    <input
                                        id={value}
                                        type="checkbox"
                                        value={value}
                                        checked={isSelectedOrder(value)}
                                        onChange={onChangeOrder}
                                    />
                                    <label htmlFor={value}>{value}</label>
                                </li>
                            ))}
                        </ul>
                    </FilterBox>
                </FiltersContent>}
            </FiltersContainer>
            <ListItemContainer>
                {dataDeal.map(item => {
                    console.log(item);
                    var dataInicioParsed = parseData(item.dataInicio, 'America/Sao_Paulo');
                    var dataFechamentoParsed = (item.dataFechamento) ? parseData(item.dataFechamento, 'Europe/Moscow') : '';
                    var faseTranslated = String(translateFase(item.fase));
                    var npsTranslated = (item.nps) ? String(translateNPS(item.nps)) : 'Não respondido';
                    var categoriaTranslated = String(findCategoria(item));
                    var classificacao = String(translateClassificacao(item.classificacao));
                    var statusFaseV2Translated = String(translateStatusFaseV2(item.statusDaFase));
                    var pipelineV2Translated = String(translatePipelineV2(item.pipelineV2));
                    var clienteDesejaFinalizarTranslated = String(translateClienteDesejaFinalizarV2(item.clienteDesejaFinalizarChamado));
                    var dataEntradaPendenteClienteParsed = (item.dataEntradaPendenteCliente) ? parseData(item.dataEntradaPendenteCliente, 'America/Sao_Paulo') : '';

                    return (
                        <Item key={item.id}
                            id={item.id}
                            descricao={item.descricao}
                            dataInicio={dataInicioParsed}
                            dataFechamento={dataFechamentoParsed}
                            resolucao={item.resolucao}
                            fase={faseTranslated}
                            nps={npsTranslated}
                            status={item.status}
                            categoria={categoriaTranslated}
                            classificacao={classificacao}
                            tempoDesenvolvimento={item.tempoDesenvolvimento}
                            userName={user.name}
                            statusFaseV2={statusFaseV2Translated}
                            pipelineV2={pipelineV2Translated}
                            idChamadoAnterior={item.idChamadoAnterior}
                            faseV2={item.faseV2}
                            linkFormulario={item.linkFormulario}
                            nomeEmailUsuario={item.nomeEmailUsuario}
                            departUserModeloPermissoes={item.departUserModeloPermissoes}
                            nomeRoleta={item.nomeRoleta}
                            desenvolvedores={item.desenvolvedores}
                            paraQuemTransferir={item.paraQuemTransferir}
                            idCardProblema={item.idCardProblema}
                            retornoPendencia={item.retornoPendencia}
                            clienteDesejaFinalizar={clienteDesejaFinalizarTranslated}
                            porqueClienteEstaFinalizandoChamado={item.porqueClienteEstaFinalizandoChamado}
                            dataEntradaPendenteCliente={dataEntradaPendenteClienteParsed}
                            idResponsavel={item.idResponsavel}
                        />
                    )
                })}
            </ListItemContainer>
        </Container>

    )
}

export default MainPage;
